var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"left-top"},[_vm._t("leftTop")],2),_c('div',{staticClass:"left-bottom"},[_vm._t("leftBottom")],2)]),_c('div',{staticClass:"right"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }